import React, { useEffect, useState } from 'react';
import TriggerModal from "./TriggerModal";
import FlowTriggerStack from "./FlowTriggerStack";
import firebase from "../../firebaseConfig";
import { TiPlus } from "react-icons/ti";
import "../../styles/generalTabs.css"

const FlowTrigger = ({ user }) => {
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalTitle, setModalTitle] = useState("");
    const [displayContent, setDisplayContent] = useState("");
    const [fieldName, setFieldName] = useState("");
    const [flowTriggerData, setflowTriggerData] = useState({
        curiosity_1 : '',
        passion_1_2 : '',
        purpose_1_3 : '',
        concentration_2 : '',
        clearGoals_2_5 : '',
        challengeSkillBalance_3 : '',
        feedback_4 : '',
        richEnv_5 : '',
        deepEnv_6 : '',
        highEnv_7 : '',
        creativity_8 : '',
        triggers_9 : '',
        autonomy_10 : ''
    });
    const [flowTriggerStacks, setFlowTriggerStacks] = useState([]);

    useEffect(() => {
        const fetchInputValue = async () => {
            try {
                if (user) {
                    const userId = user.uid;
                    const docRef = firebase.firestore().collection('users').doc(userId);
                    const docSnapshot = await docRef.get();
                    if (docSnapshot.exists) {
                        const data = docSnapshot.data().FlowTrigger_3;
                        setflowTriggerData(data);
                        const stacks = docSnapshot.data().FlowTriggerStacks_3 || [];
                        setFlowTriggerStacks(stacks);
                    }
                }
            } catch (error) {
                console.log(error);
                // Gérer les erreurs de récupération des données
            }
        };
        fetchInputValue();
    }, [user]);

    const updateInputValue = async (newValue) => {
        try {
            if (user) {
                const userId = user.uid;
                const docRef = firebase.firestore().collection('users').doc(userId);

                // Créer un objet avec le champ spécifié et sa nouvelle valeur
                const updatedData = {
                    ["FlowTrigger_3." + fieldName]: newValue
                };

                // Mettre à jour l'état dynamiquement
                setflowTriggerData(prevState => ({
                    ...prevState,
                    [fieldName]: newValue
                }));

                if (modalIsOpen) setModalIsOpen(false);
                await docRef.update(updatedData);
            }
        } catch (error) {
            console.log(error);
            // Gérer les erreurs de mise à jour des données
        }
    };

    const openModal = (fieldName, title) => {
        setDisplayContent(flowTriggerData[fieldName]);
        setFieldName(fieldName);
        setModalTitle(title);
        setModalIsOpen(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
    };

    const addStack = () => {
        const newStack = {
            singleTask: '',
            intrinsicMotivator: '',
            whyMatters: '',
            autonomyExplanation: '',
            completeConcentration: '',
            clearGoal: '',
            challenge: '',
            skill: '',
            immediateFeedback: '',
            catalystMain: '',
            catalystMainExplanation: '',
            catalystOptional1: '',
            catalystOptional1Explanation: '',
            catalystOptional2: '',
            catalystOptional2Explanation: '',
            catalystDataEntry: '',
            whenTest: '',
            whatWorked: '',
            whatDidnt: '',
            needsAdjustment: ''
        };
        const updatedStacks = [...flowTriggerStacks, newStack];
        setFlowTriggerStacks(updatedStacks);
        saveStacks(updatedStacks);
    };

    const updateStack = (index, updatedStack) => {
        const updatedStacks = [...flowTriggerStacks];
        updatedStacks[index] = updatedStack;
        setFlowTriggerStacks(updatedStacks);
        saveStacks(updatedStacks);
    };

    const deleteStack = (index) => {
        const updatedStacks = flowTriggerStacks.filter((_, i) => i !== index);
        setFlowTriggerStacks(updatedStacks);
        saveStacks(updatedStacks);
    };

    const saveStacks = async (stacks) => {
        try {
            if (user) {
                const userId = user.uid;
                const docRef = firebase.firestore().collection('users').doc(userId);
                await docRef.update({
                    FlowTriggerStacks_3: stacks
                });
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <div className="tab-pane containerDashboardContent container-fluid" role="tabpanel" id="tab-3">
            <h5 className={"mt-3"}>
                <span className="introText">
                     "As soon as the whistle blows, something triggers me." - Caeleb Dressel
                </span>
            </h5>
            <div className="container">
                <div className="col">
                    <div className="d-flex align-items-center my-4">
                        <div className="flex-grow-1 border-top border-3 border-dark"></div>
                        <h4 className="mx-4 text-uppercase mb-0">INTERNAL TRIGGERS</h4>
                        <div className="flex-grow-1 border-top border-3 border-dark"></div>
                    </div>
                    <div className="row">
                        <Card openModal={openModal} title={"COMPLETE CONCENTRATION"} subTitle={"WHAT HELPS YOU REACH COMPLETE CONCENTRATION?"} fieldName={"concentration_2"} flowTriggerData={flowTriggerData} />
                        <Card openModal={openModal} title={"CLEAR GOALS"} subTitle={"WHAT ARE YOUR CLEAR GOALS?"} fieldName={"clearGoals_2_5"} flowTriggerData={flowTriggerData} />
                        <Card openModal={openModal} title={"CHALLENGE-SKILLS BALANCE"} subTitle={"WHAT'S YOUR IDEAL RANGE & HOW WILL YOU CHALLENGE YOURSELF TO REACH YOUR GOALS?"} fieldName={"challengeSkillBalance_3"} flowTriggerData={flowTriggerData} />
                        <Card openModal={openModal} title={"IMMEDIATE FEEDBACK"} subTitle={"WHO & WHAT CAN GIVE YOU IMMEDIATE FEEDBACK?"} fieldName={"feedback_4"} flowTriggerData={flowTriggerData} />
                        <Card openModal={openModal} title={"AUTONOMY"} subTitle={""} fieldName={"autonomy_10"} flowTriggerData={flowTriggerData} />
                    </div>

                    <div className="d-flex align-items-center my-4">
                        <div className="flex-grow-1 border-top border-3 border-dark"></div>
                        <h4 className="mx-4 text-uppercase mb-0">CURIOSITY, PASSION, AND PURPOSE</h4>
                        <div className="flex-grow-1 border-top border-3 border-dark"></div>
                    </div>
                    <div className="row">
                        <Card openModal={openModal} title={"CURIOSITY"} subTitle={"WHAT ARE THEY AND HOW DO THEY CONNECT?"} fieldName={"curiosity_1"} flowTriggerData={flowTriggerData} />
                        <Card openModal={openModal} title={"PASSION"} subTitle={"WHAT IS YOUR PASSION?"} fieldName={"passion_1_2"} flowTriggerData={flowTriggerData} />
                        <Card openModal={openModal} title={"PURPOSE"} subTitle={"WHAT IS YOUR PURPOSE?"} fieldName={"purpose_1_3"} flowTriggerData={flowTriggerData} />
                    </div>

                    <div className="d-flex align-items-center my-4">
                        <div className="flex-grow-1 border-top border-3 border-dark"></div>
                        <h4 className="mx-4 text-uppercase mb-0">EXTERNAL TRIGGERS</h4>
                        <div className="flex-grow-1 border-top border-3 border-dark"></div>
                    </div>
                    <div className="row">
                        <Card openModal={openModal} title={"HIGH CONSEQUENCES"} subTitle={""} fieldName={"highEnv_7"} flowTriggerData={flowTriggerData} />
                        <Card openModal={openModal} title={"RICH ENVIRONMENTS"} subTitle={""} fieldName={"richEnv_5"} flowTriggerData={flowTriggerData} />
                        <Card openModal={openModal} title={"DEEP EMBODIMENT"} subTitle={""} fieldName={"deepEnv_6"} flowTriggerData={flowTriggerData} />
                    </div>

                    <div className="d-flex align-items-center my-4">
                        <div className="flex-grow-1 border-top border-3 border-dark"></div>
                        <h4 className="mx-4 text-uppercase mb-0">CREATIVITY TRIGGERS</h4>
                        <div className="flex-grow-1 border-top border-3 border-dark"></div>
                    </div>
                    <div className="row">
                        <Card openModal={openModal} title={"CREATIVITY TRIGGERS"} subTitle={""} fieldName={"creativity_8"} flowTriggerData={flowTriggerData} />
                    </div>

                    <div className="d-flex align-items-center my-4">
                        <div className="flex-grow-1 border-top border-3 border-dark"></div>
                        <h4 className="mx-4 text-uppercase mb-0">PERSONAL TRIGGERS</h4>
                        <div className="flex-grow-1 border-top border-3 border-dark"></div>
                    </div>
                    <div className="row">
                        <Card openModal={openModal} title={"PERSONAL TRIGGERS"} subTitle={"KINESTHETIC, BREATHWORK, AUDITORY, MENTAL, OLFACTORY, NOOTROPICS, ETC"} fieldName={"triggers_9"} flowTriggerData={flowTriggerData} />
                    </div>

                    <div className="d-flex align-items-center my-4">
                        <div className="flex-grow-1 border-top border-3 border-dark"></div>
                        <h4 className="mx-4 text-uppercase mb-0">FLOW TRIGGER STACK</h4>
                        <div className="flex-grow-1 border-top border-3 border-dark"></div>
                    </div>
                    <div className="d-flex justify-content-center mb-3">
                        <button className="btn btn-primary" onClick={addStack}>
                            <TiPlus style={{ fontSize: "1.2em", marginRight: "0.3em" }} />
                            Add Flow Trigger Stack
                        </button>
                    </div>
                    <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
                        {flowTriggerStacks.map((stack, index) => (
                            <div key={index} className="col p-2">
                                <FlowTriggerStack 
                                    stack={stack} 
                                    index={index} 
                                    updateStack={updateStack} 
                                    deleteStack={deleteStack} 
                                />
                            </div>
                        ))}
                    </div>
                </div>

            </div>

            {modalIsOpen && (
                <TriggerModal
                    title={modalTitle}
                    closeModal={closeModal}
                    content={displayContent}
                    fieldName={fieldName}
                    saveField={updateInputValue}
                />
            )}
        </div>
    );
};

const Card = ({ openModal, title, subTitle, fieldName, flowTriggerData }) => {
    const renderContent = () => {
        if (fieldName === "challengeSkillBalance_3" && flowTriggerData[fieldName]) {
            try {
                const parsed = JSON.parse(flowTriggerData[fieldName]);
                if (parsed.activity !== undefined || parsed.challenge !== undefined || parsed.skill !== undefined) {
                    return (
                        <div>
                            <strong>Activity:</strong> {parsed.activity}
                            <br />
                            <strong>Challenge:</strong> {parsed.challenge}
                            <br />
                            <strong>Skill:</strong> {parsed.skill}
                        </div>
                    );
                }
            } catch (e) {
                // Fallback to plain text if not valid JSON
                return flowTriggerData[fieldName];
            }
        } else if (flowTriggerData[fieldName]) {
            try {
                const parsed = JSON.parse(flowTriggerData[fieldName]);
                if (Array.isArray(parsed) && parsed.length > 0) {
                    return (
                        <div>
                            {parsed.map((pair, index) => (
                                <div key={index} className="mb-2">
                                    <strong>{title.charAt(0).toUpperCase() + title.slice(1).toLowerCase()} {index + 1}:</strong>
                                    <br />
                                    <strong>What helps me enter flow:</strong> {pair.helpsEnterFlow}
                                    <br />
                                    <strong>How I apply for it:</strong> {pair.howApply}
                                </div>
                            ))}
                        </div>
                    );
                }
            } catch (e) {
                // Fallback to plain text if not valid JSON
                return flowTriggerData[fieldName];
            }
        }
        return flowTriggerData[fieldName];
    };

    return (
        <div className="col-xl-6 col-xs-12 col-sm-6 mt-3" style={{ cursor: "pointer" }}>
            <div className="card">
                <div className="card-header text-center d-xxl-flex justify-content-xxl-center align-items-xxl-center" style={{ minHeight: "5em" }}>
                    <div onClick={() => openModal(fieldName, title)}>
                        <span style={{ textDecoration: "underline", cursor: "pointer", fontSize: "1.3em", fontWeight: 'bold'  }}>{title}</span>
                        {subTitle ? (
                            <p className="subtitleMaj d-xxl-flex justify-content-xxl-center align-items-xxl-center">{subTitle}</p>
                        ) : null}
                    </div>
                </div>
                <div className="p-1">
                    <div onDoubleClick={() => openModal(fieldName, title)} className="contentText p-3">{renderContent()}</div>
                </div>
            </div>
        </div>
    );
};

export default FlowTrigger;
